/** Active event update intervals for a Global Action IPAWS alert, in milliseconds. Each value is > 0. */
export const IPAWS_UPDATE_INTERVAL_OPTIONS = [
  { value: 5 * 60 * 1000, label: '5 minutes' },
  { value: 15 * 60 * 1000, label: '15 minutes' },
  { value: 30 * 60 * 1000, label: '30 minutes' },
  { value: 60 * 60 * 1000, label: '1 hour' },
  { value: 2 * 60 * 60 * 1000, label: '2 hours' },
  { value: 4 * 60 * 60 * 1000, label: '4 hours' },
  { value: 8 * 60 * 60 * 1000, label: '8 hours' },
  { value: 12 * 60 * 60 * 1000, label: '12 hours' },
  { value: 24 * 60 * 60 * 1000, label: '24 hours' },
];

/**
 * The longest interval when WEA (CMAS) is selected. The backend stamps
 * expires = now + interval + a 5-minute margin, and a WEA must expire within 24 hours of `sent`
 * (FEMA 613). EAS and NWEM allow 99.5 hours, so the 24-hour option stays for them.
 */
export const IPAWS_WEA_MAXIMUM_UPDATE_INTERVAL = (23 * 60 + 55) * 60 * 1000;

export const IPAWS_WEA_INTERVAL_NOTE =
  'With WEA selected the interval is at most 23 hours 55 minutes (FEMA 613: a WEA expires within 24 hours).';

export const IPAWS_WEA_INTERVAL_ISSUE =
  'With WEA selected, select an update interval of 23 hours 55 minutes or less (FEMA 613).';

/** True when the selected delivery channels include WEA (CMAS). */
export const hasWeaDeliveryChannel = (deliveryChannels) =>
  Array.isArray(deliveryChannels) && deliveryChannels.includes('CMAS');

/**
 * The interval options for the selected channels. With WEA, no option is above
 * `IPAWS_WEA_MAXIMUM_UPDATE_INTERVAL`, and that value is the last option.
 */
export const getIpawsUpdateIntervalOptions = (deliveryChannels) =>
  hasWeaDeliveryChannel(deliveryChannels)
    ? [
        ...IPAWS_UPDATE_INTERVAL_OPTIONS.filter(
          ({ value }) => value <= IPAWS_WEA_MAXIMUM_UPDATE_INTERVAL,
        ),
        { value: IPAWS_WEA_MAXIMUM_UPDATE_INTERVAL, label: '23 hours 55 minutes' },
      ]
    : IPAWS_UPDATE_INTERVAL_OPTIONS;

/** True when WEA is selected and the interval is above the WEA limit. */
export const isIntervalAboveWeaLimit = (intervalDuration, deliveryChannels) =>
  hasWeaDeliveryChannel(deliveryChannels) &&
  Number(intervalDuration) > IPAWS_WEA_MAXIMUM_UPDATE_INTERVAL;
